import { render, staticRenderFns } from "./AuthenticationDashboard.vue?vue&type=template&id=348f413a&scoped=true"
import script from "./AuthenticationDashboard.vue?vue&type=script&lang=ts"
export * from "./AuthenticationDashboard.vue?vue&type=script&lang=ts"
import style0 from "./AuthenticationDashboard.vue?vue&type=style&index=0&id=348f413a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348f413a",
  null
  
)

export default component.exports